import { render, staticRenderFns } from "./Riwayat.vue?vue&type=template&id=48ea6072&scoped=true&"
import script from "./Riwayat.vue?vue&type=script&lang=js&"
export * from "./Riwayat.vue?vue&type=script&lang=js&"
import style0 from "./Riwayat.vue?vue&type=style&index=0&id=48ea6072&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48ea6072",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VChip,VContainer,VIcon,VTooltip})
